module.exports = __webpack_public_path__ + "img/myMind-gray.3854d88b.svg";